import { useStore, useActions } from './useStore';

/**
 * A hook to centralize the business logic for managing global soundscapes.
 * It provides both the data and the CRUD actions for soundscapes.
 */
export const useSoundscapesManager = () => {
  const soundscapes = useStore(state => state.session?.cache?.soundscapes) ?? [];
  const {
    addSoundscape,
    updateSoundscape,
    deleteSoundscape,
  } = useActions();

  return {
    soundscapes,
    addSoundscape,
    updateSoundscape,
    deleteSoundscape,
  };
};